// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","StrollerBoxWidget":"bep_a bhm_tr","StrollerBoxWidget__imageCounselling":"bep_b bhm_kg"};